import { Routes } from '@angular/router';
import { ROUTES } from '@common/interfaces';
import { authRoutes } from 'libs/shared/web/auth/auth.routes';
import { dashboardRoutes } from 'libs/shared/web/dashboard/dashboard.routes';

export const routes: Routes = [
  { path: '', redirectTo: ROUTES.SIGN_IN, pathMatch: 'full' },
  ...authRoutes,
  ...dashboardRoutes,
];
